import { Grid } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router';
import { Colors, KebabMenu } from 'library';
import MenuIcon from '@mui/icons-material/Menu';
import WhiteHeader from './WhiteHeader';

type Routes = 'Sign Up' | 'Center Login';

export default function ActionNavBar() {
    const history = useHistory();
    const kebabOptions = ['Sign Up', 'Center Login'];

    function menuItemSelect(e: Routes | string | object) {
        if (typeof e === 'object') return;
        if (e === 'Sign Up') {
            signUpClick();
        } else if (e?.includes('Login')) {
            login();
        }
    }

    function signUpClick() {
        history.push('/signup');
    }

    function login() {
        history.push('/login');
    }

    return (
        <Grid
            container
            direction="column"
            style={{
                backgroundColor: Colors.white,
                boxShadow: 'rgb(0 0 0 / 30%) 0 0 16px',
            }}
        >
            <Grid container item style={{ width: 'auto', justifyContent: 'space-between' }} direction="row">
                <Grid item>
                    <WhiteHeader />
                </Grid>
                <Grid container item style={{ width: 'auto', alignItems: 'center' }} spacing={1}>
                    <Grid container item style={{ width: 'auto', alignItems: 'center' }} spacing={1}>
                        <Grid item style={{ width: 'auto' }}>
                            <KebabMenu
                                Icon={MenuIcon}
                                iconColor={Colors.darkNavy}
                                options={kebabOptions.map(function (opt) {
                                    return { text: opt };
                                })}
                                onSelect={menuItemSelect}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
